import { SpamScenarioId } from 'owa-junkmail-configuration';
import { createSpamStore } from '../actions/spamListMutatorActions';
import {
    initMailboxJunkEmailConfiguration,
    getMailboxJunkEmailByScenarioId,
} from 'owa-junkmail-configuration';

export default async function initSpamOption(scenarioId: SpamScenarioId) {
    // This will prime user config with junk email configuration (ex: BlockedSendersAndDomains and
    // TrustedSendersAndDomains) which are needed to populate client store.
    await initMailboxJunkEmailConfiguration();
    const junkEmailConfiguration = getMailboxJunkEmailByScenarioId(scenarioId);

    createSpamStore(scenarioId, junkEmailConfiguration);
}
